export default "__VITE_ASSET__P$R8L2h8__"